import { render, staticRenderFns } from "./PromptCategory.vue?vue&type=template&id=3cac46cd&scoped=true"
import script from "./PromptCategory.vue?vue&type=script&lang=js"
export * from "./PromptCategory.vue?vue&type=script&lang=js"
import style0 from "./PromptCategory.vue?vue&type=style&index=0&id=3cac46cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac46cd",
  null
  
)

export default component.exports